import { createContext, useContext } from "react";
import { panelApi } from "./index.js";

/**
 * The API surface is injected through context so screens never import the
 * singleton directly. Tests render with their own client + stub fetch.
 */
const ApiContext = createContext(panelApi);

export function ApiProvider({ client = panelApi, children }) {
  return <ApiContext.Provider value={client}>{children}</ApiContext.Provider>;
}

export function useApiClient() {
  return useContext(ApiContext);
}
